const WebEnvironment = {
  WEBSITE_URL: process.env.EXPO_PUBLIC_WEBSITE_URL,
  AMPLITUDE_API_KEY: process.env.EXPO_PUBLIC_AMPLITUDE_API_KEY,
  ACCESS_KEY: process.env.EXPO_PUBLIC_ACCESS_KEY,
  SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN,
} as const;

export const Environment = {
  ...WebEnvironment,
} as Record<keyof typeof WebEnvironment, string>;

Object.entries(Environment).forEach(([key, value]) => {
  if (!value) {
    throw new Error(`${key} is not set`);
  }
});
